import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { useStatsigClient } from "@statsig/react-bindings";

import { IClip } from "MVVM/@types";
import { usePortal } from "MVVM/Hooks/usePortal";
import { MatchHistoryGame } from "MVVM/State/matchHistory";
import {
  FriendClipLoginModal,
  LoginModal,
} from "MVVM/Views/Profile/Components/LogInModal";
import { MatchHistoryLoginModal } from "MVVM/Views/MatchHistory/Components/Shared/LoginModal";
import { getMatchHistoryGameEnum } from "MVVM/Views/MatchHistory/utils";

const isModalCookieSet = () =>
  document.cookie
    .split("; ")
    .some((cookie) => cookie.startsWith("login_modal_shown="));

export const useLoginModal = (allstarUser: any, delay = 5000, clip?: IClip) => {
  const { getExperiment } = useStatsigClient();
  const matchHistoryGame = useRecoilValue(MatchHistoryGame);

  const renderModal = () => {
    if (clip?.pointOfView === "OTHER") {
      const renderNewSignUpModal = getExperiment(
        "sign_up_to_claim_modal_uix",
      ).get("show_new_signup", false);

      return renderNewSignUpModal ? (
        <MatchHistoryLoginModal
          game={getMatchHistoryGameEnum(clip.game) || matchHistoryGame}
          clip={clip}
          title="signUpToClaim.title"
          defaultTitle="See Yourself In This Clip?"
          subtitle="signUpToClaim.subtitle"
          defaultSubtitle="Claim this clip and we`ll add it to your profile, so you can personalize it with your own filters &amp; effects, and share with friends!"
        />
      ) : (
        <FriendClipLoginModal clip={clip} />
      );
    }
    return <LoginModal />;
  };

  const { portalOpen, setPortalOpen, Portal } = usePortal(renderModal());

  const popModal = () => {
    if (
      (Object.keys(allstarUser).length === 0 || !allstarUser.loggedIn) &&
      !isModalCookieSet()
    ) {
      document.cookie = `login_modal_shown=true; max-age=${
        12 * 60 * 60
      }; path=/`;
      setPortalOpen(true);

      return true;
    }

    return false;
  };

  useEffect(() => {
    if (!delay) return;
    const timeout = setTimeout(popModal, delay);

    return () => clearTimeout(timeout);
  }, [allstarUser, delay, setPortalOpen]);

  return { portalOpen, popModal, setPortalOpen, Portal };
};
